import React, { Fragment, useEffect, useRef, useState } from 'react'
import 'primereact/resources/themes/lara-light-cyan/theme.css'
import { Toast } from 'primereact/toast'
import Modal from 'react-bootstrap/Modal'
import { API_URL } from '../../utils/Constants/URLS'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

const ProductRequirement = props => {
  const { id } = props
  const toast = useRef(null)
  const navigate = useNavigate()
  const token = localStorage.getItem('token')
  const [modalMessage, setModalMessage] = useState('')
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [showDeclineModal, setShowDeclineModal] = useState(false)

  // Form states
  const [typeOfSale, setTypeOfSale] = useState('')
  const [natureOfSale, setNatureOfSale] = useState('')
  const [leadSource, setLeadSource] = useState('')
  const [description, setDescription] = useState('')
  const [proposedDealAmount, setProposedDealAmount] = useState(0)
  const [sourceName, setSourceName] = useState('')
  const [enquiryDetails, setEnquiryDetails] = useState('')

  const leadDetails = useSelector(store => store.deal)

  // Prefill logic on mount
  useEffect(() => {
    if (leadDetails?.productRequirements) {
      const pr = leadDetails.productRequirements
      if (pr.typeOfSale) setTypeOfSale(pr.typeOfSale)
      if (pr.natureOfSale) setNatureOfSale(pr.natureOfSale)
      if (pr.leadSource) setLeadSource(pr.leadSource)
      if (pr.description) setDescription(pr.description)
      if (pr.proposedDealAmount) setProposedDealAmount(pr.proposedDealAmount)
      if (pr.sourceName) setSourceName(pr.sourceName)
      if (pr.enquiryDetails) setEnquiryDetails(pr.enquiryDetails)
    }
  }, [leadDetails])

  const handleCloseModal = () => {
    setShowSuccessModal(false)
    setShowDeclineModal(false)
    navigate('/view_leads')
  }

  const saveProductRequirement = async e => {
    e.preventDefault()
    try {
      const res = await fetch(`${API_URL}leads/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          productRequirements: {
            typeOfSale,
            natureOfSale,
            enquiryDetails,
            leadSource,
            proposedDealAmount,
            description,
            sourceName,
            status: 'pending'
          }
        })
      })
      const response = await res.json()
      if (response.error === false) {
        setModalMessage('Product Requirement Saved Successfully')
        setShowSuccessModal(true)
      } else {
        setModalMessage('Something Went Wrong')
        setShowDeclineModal(true)
      }
    } catch (e) {
      setModalMessage('Oops! Unable to save data')
      setShowDeclineModal(true)
    }
  }

  const updateProductRequirement = async e => {
    e.preventDefault()
    if (typeOfSale === '') {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Please Select Type of Sale',
        life: 3000
      })
    } else if (natureOfSale === '') {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Please Select Nature of Sale',
        life: 3000
      })
    } else if (leadSource === '') {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Please Select a Proper Lead Source',
        life: 3000
      })
    } else if (leadSource === 'Others' && sourceName === '') {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Please Enter the Lead Source Details',
        life: 3000
      })
    } else if (enquiryDetails === '') {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Please Enter a Proper Enquiry Details',
        life: 3000
      })
    } else if (description === '') {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Please Enter a Proper Description',
        life: 3000
      })
    } else {
      try {
        const res = await fetch(`${API_URL}leads/${id}`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'Application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            productRequirements: {
              typeOfSale,
              natureOfSale,
              enquiryDetails,
              leadSource,
              proposedDealAmount,
              description,
              sourceName,
              status: 'done'
            }
          })
        })
        const response = await res.json()
        if (response.error === false) {
          setModalMessage('Product Requirement Updated Successfully')
          setShowSuccessModal(true)
        } else {
          setModalMessage('Something Went Wrong')
          setShowDeclineModal(true)
        }
      } catch (e) {
        setModalMessage('Oops! Unable to add data')
        setShowDeclineModal(true)
      }
    }
  }

  return (
    <Fragment>
      <div>
        <form className='row g-3 needs-validation'>
          <div className='row ms-1 p-3'>
            <div className='col-md-6'>
              <label htmlFor='name' className='form-label'>
                Type of Sale <span className='text-danger'>*</span>
              </label>
              <select
                name='typeOfSale'
                required
                value={typeOfSale}
                onChange={e => setTypeOfSale(e.target.value)}
                data-section='productRequirements'
                className='form-select'
              >
                <option value=''>Select Type</option>
                <option value='Domestic'>Domestic</option>
                <option value='Export'>Export</option>
              </select>
            </div>
            <div className='col-md-6'>
              <label htmlFor='name' className='form-label'>
                Nature of Sale <span className='text-danger'>*</span>
              </label>
              <select
                name='natureOfSale'
                required
                value={natureOfSale}
                onChange={e => setNatureOfSale(e.target.value)}
                data-section='productRequirements'
                className='form-select'
              >
                <option value=''>Select Type</option>
                <option value='Product'>Product</option>
                <option value='Project'>Project</option>
              </select>
            </div>
          </div>

          <div className='row ms-1 p-3'>
            <div className='col-md-12'>
              <label htmlFor='lead-source' className='form-label'>
                Lead Source <span className='text-danger'>*</span>
              </label>
              <select
                id='leadSource'
                data-section='productRequirements'
                className='form-select'
                value={leadSource}
                onChange={e => setLeadSource(e.target.value)}
                required
              >
                <option value=''>Select</option>
                <option value='Direct Inquiry'>Direct Inquiry</option>
                <option value='Existing Customer Referral'>
                  Existing Customer Referral
                </option>
                <option value='Customer Visit / Site Visit'>
                  Customer Visit / Site Visit
                </option>
                <option value='Trade Show / Exhibition'>
                  Trade Show / Exhibition
                </option>
                <option value='Industry Seminar / Workshop'>
                  Industry Seminar / Workshop
                </option>
                <option value='Dealer / Channel Partner'>
                  Dealer / Channel Partner
                </option>
                <option value='Company Website'>Company Website</option>
                <option value='Online Advertisement'>
                  Online Advertisement
                </option>
                <option value='Social Media'>Social Media</option>
                <option value='Email Campaign'>Email Campaign</option>
                <option value='Cold Call / Telecalling'>
                  Cold Call / Telecalling
                </option>
                <option value='Inbound Phone Inquiry'>
                  Inbound Phone Inquiry
                </option>
                <option value='Walk In'>Walk In</option>
                <option value='WhatsApp / SMS Campaign'>
                  WhatsApp / SMS Campaign
                </option>
                <option value='Tenders / Bids / RFPs'>
                  Tenders / Bids / RFPs
                </option>
                <option value='Service Engineer Referral'>
                  Service Engineer Referral
                </option>
                <option value='Sales Engineer Referral'>
                  Sales Engineer Referral
                </option>
                <option value='Repeat Customer (New Requirement)'>
                  Repeat Customer (New Requirement)
                </option>
                <option value='Others'>Others (Please Specify)</option>
              </select>
            </div>
            {leadSource === 'Others' && (
              <div className='col-md-12 mt-2'>
                <label className='form-label'>
                  Source Details <span className='text-danger'>*</span>
                </label>
                <input
                  name='enquiryDetails'
                  type='text'
                  className='form-control'
                  value={sourceName}
                  onChange={e => setSourceName(e.target.value)}
                  data-section='productRequirements'
                  id='enquiry-details'
                  required
                />
              </div>
            )}
          </div>

          <Fragment>
            <div className='row ms-1 p-3'>
              <div className='col-md-6'>
                <label htmlFor='enquiry-details' className='form-label'>
                  Enquiry Details <span className='text-danger'>*</span>
                </label>
                <textarea
                  name='enquiryDetails'
                  type='text'
                  className='form-control'
                  value={enquiryDetails}
                  onChange={e => setEnquiryDetails(e.target.value)}
                  data-section='productRequirements'
                  id='enquiry-details'
                  required
                />
              </div>
              <div className='col-md-6'>
                <label htmlFor='description' className='form-label'>
                  Description <span className='text-danger'>*</span>
                </label>
                <textarea
                  name='description'
                  type='text'
                  className='form-control'
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                  data-section='productRequirements'
                  id='description'
                  required
                />
              </div>
            </div>

            <div className='col-md-12 d-flex justify-content-end gap-2'>
              <button
                onClick={saveProductRequirement}
                className='btn btn-secondary text-white'
                type='button'
              >
                Save
              </button>
              <button
                onClick={updateProductRequirement}
                className='btn add-btn text-white'
                type='submit'
              >
                Next
              </button>
            </div>
          </Fragment>
        </form>

        {/* Success & Error Modals */}
        <Modal show={showSuccessModal} centered>
          <Modal.Body>
            <div className='my-8 text-center'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                className='w-14 shrink-0 fill-green-500 inline'
                viewBox='0 0 512 512'
              >
                <path d='M383.841 171.838c-7.881-8.31-21.02-8.676-29.343-.775L221.987 296.732l-63.204-64.893c-8.005-8.213-21.13-8.393-29.35-.387-8.213 7.998-8.386 21.137-.388 29.35l77.492 79.561a20.687 20.687 0 0 0 14.869 6.275 20.744 20.744 0 0 0 14.288-5.694l147.373-139.762c8.316-7.888 8.668-21.027.774-29.344z' />
                <path d='M256 0C114.84 0 0 114.84 0 256s114.84 256 256 256 256-114.84 256-256S397.16 0 256 0zm0 470.487c-118.265 0-214.487-96.214-214.487-214.487 0-118.265 96.221-214.487 214.487-214.487 118.272 0 214.487 96.221 214.487 214.487 0 118.272-96.215 214.487-214.487 214.487z' />
              </svg>
              <h4 className='text-xl text-gray-800 font-semibold mt-4'>
                Good Job
              </h4>
              <p className='text-sm text-gray-500 leading-relaxed mt-4'>
                {modalMessage}!
              </p>
            </div>

            <button
              type='button'
              onClick={handleCloseModal}
              className='px-5 py-2.5 w-full rounded-lg text-white text-sm border-none outline-none bg-green-500 hover:bg-green-700'
            >
              Okay
            </button>
          </Modal.Body>
        </Modal>

        <Modal show={showDeclineModal} centered>
          <Modal.Body>
            <div className='my-8 text-center'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                className='w-14 fill-red-500 inline'
                viewBox='0 0 286.054 286.054'
              >
                <path
                  fill='#e2574c'
                  d='M143.027 0C64.04 0 0 64.04 0 143.027c0 78.996 64.04 143.027 143.027 143.027 78.996 0 143.027-64.022 143.027-143.027C286.054 64.04 222.022 0 143.027 0zm0 259.236c-64.183 0-116.209-52.026-116.209-116.209S78.844 26.818 143.027 26.818s116.209 52.026 116.209 116.209-52.026 116.209-116.209 116.209zm.009-196.51c-10.244 0-17.995 5.346-17.995 13.981v79.201c0 8.644 7.75 13.972 17.995 13.972 9.994 0 17.995-5.551 17.995-13.972V76.707c-.001-8.43-8.001-13.981-17.995-13.981zm0 124.997c-9.842 0-17.852 8.01-17.852 17.86 0 9.833 8.01 17.843 17.852 17.843s17.843-8.01 17.843-17.843c-.001-9.851-8.001-17.86-17.843-17.86z'
                ></path>
              </svg>
              <h4 className='text-xl text-gray-800 font-semibold mt-4'>
                Error Occured
              </h4>
              <p className='text-sm text-gray-500 leading-relaxed mt-4'>
                {modalMessage}!
              </p>
            </div>

            <button
              type='button'
              onClick={handleCloseModal}
              className='px-5 py-2.5 w-full rounded-lg text-white text-sm border-none outline-none bg-red-500 hover:bg-red-700'
            >
              Okay
            </button>
          </Modal.Body>
        </Modal>
        <Toast ref={toast} />
      </div>
    </Fragment>
  )
}

export default ProductRequirement
